import * as React from "react";
import { pluginRegistry } from "@flow/frontend/member/plugin_api";
import { multipleFixedTargets } from "../../common/campaign_target_providers";

pluginRegistry.registerCampaignTargetProvider({
  def: multipleFixedTargets,
  memberTargetLookupWidget: (props) => {
    React.useEffect(() => {
      props.onGetTarget(
        props.config.map((m) => {
          return { name: m.name, unique_id: m.guid };
        })
      );
    }, []);

    return <></>;
  },
});
